// import OneSignal from 'react-native-onesignal';
// import Constants from "expo-constants";
// OneSignal.setAppId(Constants.manifest.extra.oneSignalAppId);

import axios from 'axios';

import React from 'react';
import { StyleSheet, Text, View, TextInput, Image, TouchableOpacity, Platform, useWindowDimensions } from 'react-native';
import MyText from './MyText';
import { FontAwesome, MaterialCommunityIcons, FontAwesome5 } from '@expo/vector-icons'; 
import SvgUri from 'react-native-svg';
import Logo from './assets/icons/logo.svg';
import MySVG from './assets/MySVG';
import css from './Style'

import { createDrawerNavigator, DrawerToggleButton } from '@react-navigation/drawer';
import AsyncStorage from '@react-native-async-storage/async-storage';

export default function Header(props) {
  const {height, width} = useWindowDimensions();

  const [count, setCount] = React.useState(0);
  
  React.useEffect(() => {
    const fetchData = async () => {
      console.log("Fetching notifications");
      // const deviceState = await OneSignal.getDeviceState();
      let notifications = JSON.parse(await AsyncStorage.getItem('notifications')??'{}');
      // if(props.user && deviceState && deviceState.userId){
      if(props.user){
          axios.get('/api/getNotificationsCount.php', {
            params: {
                uuid: await AsyncStorage.getItem('uuid')
            }
          })
          .then(async (res) => {
            if(res.data){
              let seen = 0;
              res.data.forEach(dbId => {
                let hasSeen = false;
                if(notifications[dbId]){
                  hasSeen = true;
                  seen++;
                }
              })
              let temp = res.data.length-seen;
              setCount(temp);
            }
          })
      }
    }
  
    fetchData().catch(console.error);
  },[])

  // if(!props.user){
    // return <></>
  // }
  console.log(props.route.name);
  let background = styles.background;
  if(Platform.OS==='web' && props.route.name !== 'Register'){
    background = styles.webBackground;
  }
  return (
    <View style={props.user?styles.background:background}>
        <MySVG source={Logo} style={styles.logo} resizeMode={'contain'} />
        <MyText style={[css.l, styles.text]}>
            FOOTPRINT
        </MyText>
        {
          (!props.user && Platform.OS==='web')?
          <>
            <TouchableOpacity onPress={() => props.navigation.push('Landing Page')}>
              <MyText style={[css.bold, styles.headerText]}>Login</MyText>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => false}>
              <MyText style={[css.bold, styles.headerText]}>|</MyText>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => props.navigation.push('Register')}>
              <MyText style={[css.bold, styles.headerText]}>Register</MyText>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => false}>
              <MyText style={[css.bold, styles.headerText]}>|</MyText>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => false}>
              <MyText style={[css.bold, styles.headerText]}>About</MyText>
            </TouchableOpacity>
            <TouchableOpacity onPress={() => false}>
                <MyText style={[styles.headerButton, css.bold, {fontFamily: 'Futura Heavy'}]}>
                    GET THE APP
                </MyText>
            </TouchableOpacity>
          </>
          :null
        }
        { props.user &&
          <>
          <TouchableOpacity onPress={() => props.navigation.push('My Notifications')}>
            <View style={styles.notificationsContainer}>
                <MaterialCommunityIcons name="bell" size={30} color="white" />
                { count != 0 &&
                  <MyText style={[css.sm, styles.notifications]}>
                      {count}
                  </MyText>
                }
            </View>
          </TouchableOpacity>
          {
            width < 992?
            <TouchableOpacity onPress={() => props.bottomSheet.current?.present()} style={{marginLeft: 15}} hitSlop={{top: 20, bottom: 20, left: 0, right: 20}}>
              <View>
                    {/* <DrawerToggleButton/> */}
                  <FontAwesome5 name="bars" size={20} color="white" />
              </View>
            </TouchableOpacity>
            :null
          }
          </>
        }
    </View>
  );
}

const styles = StyleSheet.create({
  webBackground: {
    display: 'flex',
    backgroundColor: 'transparent',
    paddingTop: Platform.OS==='web'?15:45,
    paddingBottom: 15,
    paddingRight: 20,
    paddingLeft: 20,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    zIndex: 10000,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  },
  headerText: {
    color: 'white',
    marginRight: 20,
    fontFamily: 'Futura Heavy',
  },
  headerButton: {
    paddingVertical: 10,
    paddingHorizontal: 20,
    backgroundColor: '#461b6f',
    color: 'white',
    borderRadius: 0,
    overflow: 'hidden',
    textAlign: 'center',
    marginRight: 20
  },
  background: {
    display: 'flex',
    backgroundColor: '#461b6f',
    paddingTop: Platform.OS==='web'?15:45,
    paddingBottom: 15,
    paddingRight: 20,
    paddingLeft: 20,
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    zIndex: 10000,
    overflow: 'hidden'
  },
  text: {
    color: 'white',
    fontFamily: 'Futura Heavy',
    flexGrow: 1,
    flexShrink: 1
  },
  logo: {
      width: 34,
      height: 34,
      marginRight: 10,
      backgroundSize: 'contain',
  },
  notificationsContainer: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
  },
  notifications: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      left: -4,
      top: 2,
      borderRadius: 10,
      overflow: 'hidden',
      width: 20,
      lineHeight: 19,
      height: 20,
      color: 'white',
      borderWidth: 1,
      borderColor: 'white',
      backgroundColor: '#461b6f',
      fontWeight: 'bold',
      textAlign: 'center'
  }
});
